module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_welcome_board-0e2e0739775e154b444eec8e76d8f895.jpg";